import { render, staticRenderFns } from "./boxnum.vue?vue&type=template&id=314d0d9c&scoped=true"
import script from "./boxnum.vue?vue&type=script&lang=js"
export * from "./boxnum.vue?vue&type=script&lang=js"
import style0 from "./boxnum.vue?vue&type=style&index=0&id=314d0d9c&prod&lang=scss&scoped=true"
import style1 from "./boxnum.vue?vue&type=style&index=1&id=314d0d9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314d0d9c",
  null
  
)

export default component.exports